// import { motion } from "framer-motion";
// import { useNavigate } from "react-router-dom";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Autoplay } from "swiper/modules";
// import { useEffect, useState } from "react";

// import "swiper/css";
// import "swiper/css/navigation";

// const ProductSection = () => {

//   const navigate = useNavigate();
//   const [data, setData] = useState([]);

//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         const res = await fetch("https://lappyshop.onrender.com/api/get-product");
//         const result = await res.json();

//         if (result.success) {
//           setData(result.data);
//         }
//       } catch (err) {
//         console.log(err);
//       }
//     };
//     fetchProducts();
//   }, []);

//   const safeProducts = data?.filter(p => p && p.productImage?.length);
//   const dealProduct = safeProducts[0];

//   // 🔥 CURVE ANIMATION FUNCTION
//   const getCurveY = (index) => {
//     const curve = [0, -10, 10, -6, 6]; // wave pattern
//     return curve[index % curve.length];
//   };

//   return (
//     <div className="container mx-auto px-3 md:px-4 mt-12">

//       {/* 🔥 DEAL CARD */}
//       {dealProduct && (
//         <motion.div
//           initial={{ opacity: 0, y: 40 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           className="mb-6 bg-gradient-to-r from-blue-600 to-indigo-700 text-white p-4 md:p-6 rounded-2xl shadow-lg cursor-pointer"
//           onClick={() => navigate(`/product/${dealProduct._id}`)}
//         >
//           <div className="flex items-center gap-4">

//             <img
//               src={dealProduct.productImage?.[0]}
//               className="h-20 md:h-28 object-contain"
//             />

//             <div>
//               <h3 className="text-sm opacity-80">🔥 Deal of the Week</h3>

//               <p className="text-sm md:text-base line-clamp-2">
//                 {dealProduct.productName}
//               </p>

//               <p className="text-lg md:text-xl font-bold mt-1">
//                 ₹{dealProduct?.variants?.[0]?.price || 0}
//               </p>
//             </div>

//           </div>
//         </motion.div>
//       )}

//       {/* HEADER */}
//       <div className="flex justify-between items-center mb-4">
//         <h2 className="text-lg md:text-2xl font-bold">New Arrivals</h2>

//         <button
//           onClick={() => navigate("/product-category")}
//           className="text-blue-600 text-sm md:text-base"
//         >
//           View All →
//         </button>
//       </div>

//       {/* 🔥 SLIDER */}
//       <Swiper
//         modules={[Navigation, Autoplay]}
//         autoplay={{ delay: 2500, disableOnInteraction: false }}
//         grabCursor={true}
//         navigation={false}
//         spaceBetween={12}
//         breakpoints={{
//           0: { slidesPerView: 1.2 },
//           480: { slidesPerView: 1.6 },
//           640: { slidesPerView: 2 },
//           768: { slidesPerView: 2.5 },
//           1024: { slidesPerView: 3 },
//           1280: { slidesPerView: 4 },
//         }}
//       >

//         {safeProducts.map((product, i) => {

//           const price = product?.variants?.[0]?.price || 0;

//           return (
//             <SwiperSlide key={product._id}>

//               <motion.div
//                 initial={{ opacity: 0, y: 40 }}
//                 whileInView={{
//                   opacity: 1,
//                   y: getCurveY(i) // 🔥 CURVE EFFECT
//                 }}
//                 transition={{
//                   delay: i * 0.05,
//                   type: "spring",
//                   stiffness: 120
//                 }}
//                 whileHover={{ y: -12, scale: 1.03 }}
//                 onClick={() => navigate(`/product/${product._id}`)}
//                 className="bg-white p-3 md:p-4 rounded-xl shadow-sm hover:shadow-xl transition group cursor-pointer"
//               >

//                 {/* IMAGE */}
//                 <div className="h-24 md:h-32 flex justify-center items-center overflow-hidden">
//                   <motion.img
//                     src={product.productImage?.[0]}
//                     className="h-full object-contain"
//                     whileHover={{ scale: 1.15 }}
//                     transition={{ duration: 0.3 }}
//                   />
//                 </div>

//                 {/* NAME */}
//                 <p className="mt-2 text-xs md:text-sm font-medium line-clamp-2">
//                   {product.productName}
//                 </p>

//                 {/* PRICE */}
//                 <p className="mt-1 text-blue-600 font-bold text-sm md:text-lg">
//                   ₹{price}
//                 </p>

//                 {/* BUTTON */}
//                 <motion.button
//                   whileTap={{ scale: 0.9 }}
//                   onClick={(e) => {
//                     e.stopPropagation(); // 🔥 IMPORTANT
//                     navigate(`/product/${product._id}`);
//                   }}
//                   className="mt-2 w-full bg-blue-600 text-white py-1 rounded text-xs md:text-sm opacity-0 group-hover:opacity-100 transition"
//                 >
//                   See Details
//                 </motion.button>

//               </motion.div>

//             </SwiperSlide>
//           )
//         })}

//       </Swiper>

//     </div>
//   );
// };

// export default ProductSection;
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useEffect, useState } from "react";

import "swiper/css";

const ProductSection = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch("https://lappyshop.onrender.com/api/get-product");
        const result = await res.json();

        if (result.success) {
          setData(result.data);
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchProducts();
  }, []);

  const safeProducts = data?.filter(p => p && p.productImage?.length);

  const gradients = [
    "from-blue-500 to-cyan-400",
    "from-pink-500 to-purple-500",
    "from-orange-500 to-yellow-400",
  ];

  return (
    <div className="container mx-auto px-4 mt-12">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl md:text-2xl font-bold">Featured Products</h2>

        <button
          onClick={() => navigate("/product-category")}
          className="text-blue-600 text-sm md:text-base"
        >
          View All →
        </button>
      </div>

      {/* SLIDER */}
      <Swiper
        modules={[Autoplay]}
        autoplay={{ delay: 2500 }}
        spaceBetween={20}
        breakpoints={{
          0: { slidesPerView: 1.2 },
          480: { slidesPerView: 1.6 },
          640: { slidesPerView: 2 },
          768: { slidesPerView: 2.5 },
          1024: { slidesPerView: 3 },
          1280: { slidesPerView: 4 },
        }}
      >
        {safeProducts.map((product, i) => {

          const gradient = gradients[i % gradients.length];
          const price = product?.variants?.[0]?.price || 0;

          return (
            <SwiperSlide key={product._id}>

              <motion.div
                whileHover={{ y: -10, scale: 1.03 }}
                className={`relative rounded-2xl p-5 text-white shadow-xl bg-gradient-to-br ${gradient} overflow-hidden group cursor-pointer`}
                onClick={() => navigate(`/product/${product._id}`)}
              >

                {/* PRICE TAG */}
                <div className="absolute top-3 right-3 bg-black/30 px-3 py-1 text-xs rounded-full backdrop-blur">
                  ₹{price}
                </div>

                {/* IMAGE SWAP */}
                <div className="flex justify-center mb-4 relative h-32">

                  {/* FIRST IMAGE */}
                  <img
                    src={product.productImage?.[0]}
                    className="h-full object-contain absolute transition duration-500 group-hover:opacity-0 group-hover:scale-110"
                  />

                  {/* SECOND IMAGE */}
                  {product.productImage?.[1] && (
                    <img
                      src={product.productImage?.[1]}
                      className="h-full object-contain absolute opacity-0 transition duration-500 group-hover:opacity-100 group-hover:scale-110"
                    />
                  )}

                </div>

                {/* TITLE */}
                <h3 className="font-bold text-lg mb-1">
                  PRODUCT
                </h3>

                {/* NAME */}
                <p className="text-xs opacity-90 line-clamp-2 mb-2">
                  {product.productName}
                </p>

                {/* STARS */}
                <div className="text-yellow-300 text-sm mb-3">
                  ⭐⭐⭐⭐☆
                </div>

                {/* BUTTON */}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/product/${product._id}`);
                  }}
                  className="bg-white text-black text-xs px-4 py-1.5 rounded-full font-semibold hover:scale-105 transition"
                >
                  ADD TO CART
                </button>

                {/* GLOW */}
                <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-white/20 rounded-full blur-3xl"></div>

              </motion.div>

            </SwiperSlide>
          );
        })}
      </Swiper>

    </div>
  );
};

export default ProductSection;